import { CaretDown, CaretUp, CaretUpDown } from '@phosphor-icons/react';
import { SortOrder } from 'antd/es/table/interface';

const IconSort = ({
  props,
}: {
  props: {
    sortOrder: SortOrder;
  };
}) => {
  return (
    <div className='flex justify-center items-center'>
      <span>
        {' '}
        {props?.sortOrder === 'ascend' ? (
          <CaretUp size={18} />
        ) : props?.sortOrder === 'descend' ? (
          <CaretDown size={18} />
        ) : (
          <CaretUpDown size={18} />
        )}
      </span>
    </div>
  );
};

export default IconSort;
